import React from "react";
import styles from "./AboutMain.module.css";
import bfDayview from "../../Components/Assets/aboutImg/bf_dayview.jpg";
import bfNightview from "../../Components/Assets/aboutImg/bf_nightview.jpg";
import bfRooftopNightview from "../../Components/Assets/aboutImg/bf_rooftop_nightview.jpg";

const AboutUs = () => {
  return (
    <div className={styles["about-us-container"]}>
      {/* about intro  */}
      <div className={styles["intro-section"]}>
        <h2>Design Your Health</h2>
        <p className={styles["content"]}>
          BODYFRIEND, the No. 1 health care group, designs your health.
        </p>
      </div>

      {/* about image 1 */}
      <div className={styles["image-section"]}>
        <img src={bfRooftopNightview} alt="Bodyfriend Building" />
      </div>

      {/* about content 1 */}
      <div className={styles["content-inner-section"]}>
        <h2>
          The Company is committed to the dream of 'extending healthy span by 10
          years.'
        </h2>
        <p className={styles["content"]}>
          <span className={styles["span-content"]}>
            BODYFRIEND’s mission is to extend the health span of humankind by 10
            years.
          </span>
          <br></br>
          <br></br>
          Medical advancements have increased life expectancy, but 'healthy
          span,' which refers to the period of a healthy life without disease,
          is stagnating, and the gap is widening. To narrow the gap, BODYFRIEND
          has established convergence R&D organizations, such as the technology
          lab, design lab, and medical R&D center, with more than 200
          researchers dedicated to R&D activities. And, the Company is reaping
          the achievements one by one. Extending the healthy span by 10 years is
          no longer a dream.
        </p>
      </div>

      {/* about image 2 */}
      <div className={styles["image-section"]}>
        <img src={bfNightview} alt="Massage Chair" />
      </div>

      {/* about content 2 */}
      <div className={styles["content-inner-section"]}>
        <h2>Taking on challenges that have never been seen before.</h2>
        <p className={styles["content"]}>
          <span className={styles["span-content"]}>
            BODYFRIEND opens a new horizon.
          </span>
          <br></br>
          <br></br>
          Having taken on unprecedented challenges for the sake of our
          customers' health, BODYFRIEND has made extraordinary attempts to
          introduce new products without taking easy and apparent paths.
          <br></br>
          <br></br>
          Having established the first medical R&D center, launched the first
          natural latex bed brand and the first self-replaceable direct water
          purifier, and developed the first brain and metal massage features as
          well as the first juvenile massage chair, the Company has pioneered
          new horizons that others have not stepped to provide real solutions to
          help our customers get healthy.
        </p>
      </div>

      {/* about image 3 */}
      <div className={styles["image-section"]}>
        <img src={bfDayview} alt="Luxury Bed" />
      </div>

      {/* about content 3 */}
      <div className={styles["content-inner-section"]}>
        <h2>Pursuing affordable luxury.</h2>
        <p className={styles["content"]}>
          <span className={styles["span-content"]}>
            BODYFRIEND aims at the value of luxury goods and healthy grace.
          </span>
          <br></br>
          <br></br>
          The Company creates luxury products by putting everything it has into
          each product. The Company strives to make the customers healthier and
          more elegant, from their body and mind to their lifestyle and mindset.
          <br></br>
          <br></br>
          BODYFRIEND's 'luxury' is the belief in providing not only technology
          and design but also a happy experience for users. It's a healthy
          lifestyle. In addition, the rental system independently developed by
          BODYFRIEND realizes affordable luxury.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
